<div class="container-fluid px-4 mt-4 mb-5" *ngIf="facilityId>0;else noId">
    <div class="row">
        <div class="col-xl-12">
            <div class="card h-100">
                <div class="card-header">
                    <!-- toolbar -->
 
                        <form [formGroup]="form">
                            <div class="row">
                                <div class="col-md-4 pt-3">
                                    <div class="btn-group shadow-lg" style="border-radius: 10px;">
                                        <button class="btn" (click)="cambiarMes(-1)">
                                            <i class="fas fa-chevron-left"></i>
                                        </button>
                                        <span class="btn">{{ obtenerNombreMes(mesActual.getMonth()) | uppercase
                                            }}</span>
                                        <button class="btn" (click)="cambiarMes(1)">
                                            <i class="fas fa-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-8 pt-3">
                                    <div class="input-group">
                                        <span class="input-group-text"><i class="fa-solid fa-filter"></i></span>
                                        <select class="form-select form-control" formControlName="active">
                                            <option [value]="0">TODAS</option>
                                            <option [value]="1">ACTIVOS</option>
                                            <option [value]="2">FINALIZADOS</option>
                                        </select>
                                        <select class="form-select form-control" formControlName="rounds_type_id">
                                            <option [value]="0">TODAS</option>
                                            <option *ngFor="let item of types" [value]="item?.id">{{item?.tag|
                                                uppercase}}
                                            </option>
                                        </select>
                                        <button class="input-group-text" (click)="setOrder()">
                                            <i class="fa-solid fa-arrow-up-wide-short"
                                                *ngIf="this.form.get('order')?.value==1"></i>
                                            <i class="fa-solid fa-arrow-down-wide-short"
                                                *ngIf="this.form.get('order')?.value==2"></i>
                                        </button>
                                        <select class="form-select form-control" formControlName="orderType">
                                            <option value="1">FECHA</option>
                                            <option value="2">ID RONDA</option>

                                        </select>
                                        <button (click)="get()" class="btn btn-secondary">
                                            <i class="fa-solid fa-search"></i>
                                        </button>
                                        <button type="button" class="btn btn-success"
                                            (click)="generateReport(mdlReport)">
                                            <i class="fa-solid fa-file-excel"></i></button>
                                    </div>

                                </div>

                            </div>
                        </form>
              
                    <!-- /toolbar -->
                </div>
                <div class="card-body">
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                        (pageChange)="search()"></ngb-pagination>
                    <div class="table-responsive">
                        <table class="table user-list">
                            <thead>
                                <tr>
                                    <th><span>FOLIO</span></th>
                                    <th><span>HORARIO</span></th>
                                    <th><span>RONDA</span></th>
                                    <th><span>INSTALACIÓN</span></th>
                                    <th><span>NOVEDADES</span></th>
                                    <th><span>CUMPLIMIENTO</span></th>
                                </tr>
                            </thead>
                            <tbody *ngIf="items?.length>0; else noData">
                                <tr *ngFor="let item of items">
                                    <td>{{item?.id}}</td>
                                    <td>
                                        <i class="fa-regular fa-clock"></i>
                                        <small>
                                            {{item?.start_date | date:' HH:mm-dd/MM/y'}} </small>
                                        <b *ngIf="item?.rounds_type_id!=3"> - </b>
                                        <small *ngIf="item?.rounds_type_id!=3">
                                            {{item?.end_date | date:' HH:mm-dd/MM/y'}}</small>
                                        <br>
                                        <span class="badge bg-success" *ngIf="item?.active">Activo</span>
                                        <span class="badge bg-danger" *ngIf="!item?.active">Finalizada</span>
                                    </td>
                                    <td>

                                        <small class="badge"
                                            [ngClass]="{'bg-primary': item?.rounds_type?.id == 1, 'bg-success': item?.rounds_type?.id == 2,'bg-warning': item?.rounds_type?.id == 3}">
                                            {{item?.rounds_type?.tag}}</small><br>
                                        <small>
                                            <span *ngIf="item?.alert_notification_prev>0">
                                                <i class="fa-solid fa-paper-plane small"></i> <i
                                                    class="fa-solid fa-hourglass-end"></i>
                                            </span>

                                            <span class="ms-1" *ngIf="item?.start_notification>0">
                                                <i class="fa-solid fa-paper-plane small"></i><i
                                                    class="fa-solid fa-clipboard-check"></i>
                                            </span>

                                            <span class="ms-1" *ngIf="item?.delay_notification_all>0">
                                                <i class="fa-solid fa-paper-plane small"></i> <i
                                                    class="fa-solid fa-envelope-circle-check"></i>
                                            </span>
                                        </small>

                                    </td>
                                    <td>
                                        <span>{{item?.facility?.name| uppercase}}</span>
                                    </td>
                                    <td>
                                        <i class="fa-solid fa-circle-exclamation text-danger" *ngIf="item?.totalObs>0"></i> ({{item?.totalObs}})
                                        <i class="fa-solid fa-circle-check text-success" *ngIf="item?.totalObs==0"></i>
                                    </td>
                               

                                    <td>
                                        <div class="d-flex align-items-end justify-content-between">
                                            <div class="progress flex-grow-1 me-2" role="progressbar"
                                                aria-label="Compliance Progress" aria-valuemin="0" aria-valuemax="100">
                                                <div class="progress-bar" [style]="{'width': item?.compliance + '%'}">{{
                                                    item?.compliance }}%</div>
                                            </div>
                                            <button *ngIf="item?.rounds_records?.length>0" class="btn btn-warning btn-sm btn-round"
                                                type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#coll' + item?.id"
                                                aria-expanded="false">
                                                <i class="fa-solid fa-eye"></i>
                                            </button>
                                        </div>
                                        <small *ngIf="item?.range?.hours || item?.range?.minutes">
                                            <i class="fa-solid fa-user-clock text-danger"></i>
                                            <span *ngIf="item?.range?.hours>0"> {{item?.range?.hours}} hora </span>
                                            <span *ngIf="item?.range?.minutes>0"> {{item?.range?.minutes}}</span> minutos
                                            aproximados
                                        </small>
                                        <div>
                                            <div class="collapse" id="coll{{item?.id}}">
                                                <div class="card card-body shadow-sm p-1 m-1"
                                                    *ngFor="let sitem of item?.rounds_records">
                                                    <!-- Detalle de la ronda -->
                                                    <small>
                                                        <i *ngIf="sitem?.status_id==1"
                                                            class="fa-solid fa-circle-check text-success me-1"></i>
                                                        <i *ngIf="sitem?.status_id==0" class="fa-solid fa-ban text-danger"></i>
                                                        <i class="fas fa-map-marker-alt ms-1"></i> {{ sitem?.rounds_tags?.location
                                                        || " Sin ubicación" }}
            
                                                        <i *ngIf="sitem?.status_id==1" class="far fa-clock ms-1"></i>
                                                        <span *ngIf="sitem?.status_id==1">{{ sitem?.update_in }}</span>
                                                        <i *ngIf="sitem?.status_id==1"
                                                            class="fa-solid fa-person-military-pointing ms-1"></i>{{
                                                        sitem?.guards?.name }} {{ sitem?.guards?.lastname }} <span class="badge ms-1" *ngIf="sitem?.guards?.position_name" [style.background]="sitem?.guards.position_color || '#6c757d'">{{ sitem?.guards.position_name | uppercase }}</span>
                                                        <span *ngIf="sitem?.obs" class="text-danger"><b>Observación: </b>{{sitem?.obs}}</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </td>


                                </tr>

                            </tbody>
                            <ng-template #noData>
                                <tbody>
                                    <td colspan="7" class="fw-lighter text-muted">No se encontraron Registros</td>
                                </tbody>
                            </ng-template>
                        </table>
                    </div>
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                        (pageChange)="search()"></ngb-pagination>
                </div>
            </div>
        </div>
    </div>

</div>
<ng-template #noId>
    No se ha recibido el identificador de la instalación
</ng-template>

<ng-template #mdlReport let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">
                <i class="fas fa-spinner fa-spin mr-2" *ngIf="loading"></i>{{loading?"Generando reporte...":"Descargar
                Reporte"}}
            </h5>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div *ngIf="loading">
                <p>Cargando...</p>
            </div>
            <div *ngIf="!loading">
                <a [href]="pathDownload" [download]="pathDownload" target="_blank" class="btn btn-success">
                    <i class="fas fa-download mr-2"></i>Descargar archivo
                </a>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-warning" (click)="d('Cross click')">Cancelar</button>
        </div>
    </div>
</ng-template>